export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'